<template>
  <div class="">
    <homepage />
    <filters />
  </div>
</template>

<script>
// @ is an alias to /src
import Homepage from '@/components/Homepage';
import Filters from '@/components/filter/Filters';

export default {
  name: 'Home',
  components: {
    Homepage,
    Filters,
  },
};
</script>
